import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Cell } from 'react-table';
import TableCommon from 'Components/Common/Table/TableCommon';
interface IListCD {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export default function ManagerTable({ dataSource }: { dataSource: IListCD }): JSX.Element {
  const columns = useMemo(
    () => [
      {
        Header: '',
        accessor: 'empty',
        className: 'pe-none',
        columns: [
          {
            Header: 'ID',
            accessor: 'id',
            width: '100',
          },
          {
            Header: 'Tên',
            accessor: 'name',
            width: '400',
            Cell: ({ row }: Cell<IListCD>) => {
              return (
                <Link
                  to={{
                    pathname: `/admin/managers/${row.original.id}`,
                    state: { id: row.original.id },
                  }}
                  className={`${!row.original.name && 'text-decoration-none text-black pe-none'}`}
                >
                  <span className="d-block text-truncate text-start">{row.original.name}</span>
                </Link>
              );
            },
            sortType: (rowA: any, rowB: any, columnId: string, desc: boolean) => {
              const defaultVal = desc ? 'A' : 'Z';
              return (rowA?.original?.name ?? defaultVal).localeCompare(
                rowB?.original?.name ?? defaultVal,
              );
            },
          },
          {
            Header: 'Email',
            accessor: 'email',
            width: '400',
            sortType: (rowA: any, rowB: any, columnId: string, desc: boolean) => {
              const defaultVal = desc ? 'A' : 'Z';
              return (rowA?.original?.email ?? defaultVal).localeCompare(
                rowB?.original?.email ?? defaultVal,
              );
            },
          },
          {
            width: '400',
            Header: 'Số điện thoại',
            accessor: 'phone',
          },
          {
            width: '200',
            Header: 'Vai trò',
            accessor: 'roleCd',
          },
        ],
      },
    ],
    [],
  );

  return (
    <>
      <TableCommon
        classTable="table-serial-number"
        heightBody="calc(100vh - 200px)"
        data={dataSource}
        columns={columns}
        messageNoData="Không có kết quả tìm kiếm."
      />
    </>
  );
}
